import { atom } from "recoil";

const LastFlightDetailsCallAtom = atom<null | Date>({
    default: null,
    key: 'lastFlightDetailsCall'
})

export default LastFlightDetailsCallAtom;